// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2X8cD","radioRow":"SimpleQuestionBuilderModal_radioRow__29rU1"};